export enum TitleKeys {
  Favorite = 'favorite',
  Today = 'today',
  Yesterday = 'yesterday',
  Previous3Days = 'previous3Days',
  Previous7Days = 'previous7Days',
  Previous30Days = 'previous30Days',
  Earlier = 'earlier',
}
